var CompanyJoin = (function () {

    var $companyJoinLayer;

    return {
        openLayer: openLayer,
        closeLayer: closeLayer,
    }

    function openLayer() {
        $companyJoinLayer = $("#companyJoinLayer");
        $companyJoinLayer.find("#joinInput").val("");
        $companyJoinLayer.find("#joinInput").removeClass("error");
        $companyJoinLayer.find("#errMsg").css("display", "none");
        $companyJoinLayer.find("#helpMsg").css("display", "block");
        if(Often.isAct("signup")) {
            $companyJoinLayer.find("#companyJoinHeader").css("display", "none");
            $("#userStep").fadeOut(0);
            $("#basicStep").fadeOut(0);
            //스크롤 내려가는 이슈 있어서 top으로 고정
            $(document).scrollTop(0);
        } else {
            $("#allMainContent, #bottomToolList").css("display", "none");
        }
        $companyJoinLayer.fadeIn(200);
        addEvent();
        GoogleTagManager.collect({event: 'joinup1'});
    }

    function closeLayer() {
        $("#allMainContent").css("display", "block");
        $companyJoinLayer.css("display", "none");
    }

    function addEvent() {
        $companyJoinLayer.off("click").on("click", clickCompanyJoinLayer)
            .off("keyup").on("keyup", keyUpCompanyJoinLayer);
        $companyJoinLayer.find("#joinInput").off("keydown").on("keydown", keydownJoinInput)
    }

    function clickCompanyJoinLayer(e) {
        var $eTarget = $(e.target);

        if (closeBtnAndAction($eTarget)) return;
        if (companyJoinBtnAndAction($eTarget)) return;

        function closeBtnAndAction($eTarget) {
            var $closeBtn = $eTarget.findUp("#closeBtn");
            if ($closeBtn.length === 0) return false;
            closeLayer();
            return true;
        }

        function companyJoinBtnAndAction($eTarget) {
            var $companyJoinBtn = $eTarget.findUp("#companyJoinBtn");
            if ($companyJoinBtn.length === 0) return false;
            var subDomain = $companyJoinLayer.find("#joinInput").val();
            if (!checkValidJoinInput(subDomain)) {
                $companyJoinLayer.find("#joinInput").addClass("error");
                $companyJoinLayer.find("#errMsg").css("display", "block");
                $companyJoinLayer.find("#helpMsg").css("display", "none");
                return true;
            }
            CheckJoinPopup.openCheckJoinPopup(subDomain);
            return true;
        }
    }

    function keyUpCompanyJoinLayer(e) {
        var $eTarget = $(e.target);

        if (joinInputAndAction($eTarget)) return;

        function joinInputAndAction($eTarget) {
            var $joinInput = $eTarget.findUp("#joinInput");
            if ($joinInput.length === 0) return false;
            var subDomain = $joinInput.val();
            if (subDomain === "" || checkValidJoinInput(subDomain)) {
                $companyJoinLayer.find("#joinInput").removeClass("error");
                $companyJoinLayer.find("#errMsg").css("display", "none");
                $companyJoinLayer.find("#helpMsg").css("display", "block");
            } else {
                $companyJoinLayer.find("#joinInput").addClass("error");
                $companyJoinLayer.find("#errMsg").css("display", "block");
                $companyJoinLayer.find("#helpMsg").css("display", "none");
            }

            return true;
        }
    }

    function checkValidJoinInput(subDomain) {
        var regex = /^[A-Za-z0-9-]{3,50}$/;
        return regex.test(subDomain);
    }

    function keydownJoinInput(e) {
        const $eTarget = $(e.target);

        if(!KeyCheck.isKey(e, "ENTER")) return;
        const $joinInput = $eTarget.closest("#joinInput");
        var subDomain = $joinInput.val();
        if (!checkValidJoinInput(subDomain)) {
            $joinInput.addClass("error");
            $companyJoinLayer.find("#errMsg").css("display", "block");
            $companyJoinLayer.find("#helpMsg").css("display", "none");
            return true;
        }
        CheckJoinPopup.openCheckJoinPopup(subDomain);
    }
})();